import { render, staticRenderFns } from "./CommissionDistributionRuleSetCreate.vue?vue&type=template&id=66aee07c"
import script from "./CommissionDistributionRuleSetCreate.vue?vue&type=script&lang=js"
export * from "./CommissionDistributionRuleSetCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports